import { instance } from '@payments-checkout/shared/helpers/index';
import { useSessionId } from '@payments-checkout/shared/providers';
import { UseMutationOptions, useMutation } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { useParams } from 'next/navigation';


export async function installmentsSettings(
  paymentLinkId: string,
  sessionId?: string,
  quoteId?: string
) {
  return await instance.post(
    `paymentlinks/${paymentLinkId}/sessions/${sessionId}/calculate-installments`, {
      quote_id: quoteId,
    }
  );
}

export const useInstallmentsSettings = (
  options?: Omit<
    UseMutationOptions<unknown, AxiosError, { quoteId: string }>,
    'mutationFn'
  >
) => {
  const params = useParams<{ paymentLinkId: string }>();
  const { sessionId } = useSessionId();

  return useMutation({
    mutationFn: (variables: { quoteId: string }) =>
      installmentsSettings(params.paymentLinkId, sessionId, variables.quoteId),
    ...options,
  });
};
